function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M44.14,109A364.81,364.81,0,0,1,97.37,69.3C173.61,23.48,260-6.9,349.94,1.35c37.54,3.44,77.36,10.19,110.8,28.49,31.51,17.24,45.07,43.79,48.82,78.56,5.26,48.75-42.07,42.7-74.86,55-23.94,9-25.21,22.93-34.88,42.81-18,36.9-50.51,62-89.82,72.71-36.11,9.82-82.69,20.84-115.7-2.8-29.13-20.86-61.1-34.62-96.45-40.64-22.82-3.89-45.09-4.53-66.16-15.13C-25.93,191.36,5.32,144.14,44.14,109Z"
}));

function SvgBackgroundW3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 509.96 290.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundW3);
export default __webpack_public_path__ + "static/media/background-w-3.fdec3f93.svg";
export { ForwardRef as ReactComponent };